/**
 * Solves cookies manipulation, it basically maps `document.cookie` to the object type
 * and helps easily getting values of cookies by his name
 *
 * @param {string}  keyName - A string param, Key for Cookies.
 * @returns {String} Returns the exact cookie value.
 */
function getCookieByName(keyName) {
  let result = '';

  if (!keyName) {
    return result;
  }

  // Note: convert string to object
  const cookieObj = document.cookie.split(';').reduce((acc, cookieString) => {
    if (cookieString.includes('=')) {
      try {
        const [key, value] = cookieString.split('=');

        acc[key.trim()] = value.trim();
      } catch (e) {
        console.error(`utils::getCookieByName(keyName) is failed`);
      }
    }

    return acc;
  }, {});

  result = cookieObj[keyName] || '';

  return result;
}

export default getCookieByName;
